import Modal from '@material-ui/core/Modal';
import { ReactNode } from 'react';

interface ModalContainerProps {
   children: ReactNode
   open: boolean
   handleClose: () => unknown
}

export const ModalContainer = (props: ModalContainerProps) => { 
   const { open, handleClose } = props;
   return (
      <Modal
         open={open}
         onClose={handleClose}
         aria-labelledby="simple-modal-title"
         aria-describedby="simple-modal-description"
      >
         <>
            {props.children}
         </>
      </Modal>
   )
}